const translations = {
  // ── Sub Dashboard ──
  'sub.dashboard.title': '我的工作',
  'sub.dashboard.subcontractor': '分包商',
  'sub.dashboard.projectsCount': '{count} 个项目',
  'sub.dashboard.instructionsCount': '{count} 个指示',
  'sub.dashboard.assignedProjects': '分配的项目',
  'sub.dashboard.noProjectsAssigned': '未分配项目',
  'sub.dashboard.noProjectsAssignedDesc': '您目前没有分配到任何项目。Japan Homes 将在项目设置完成后将您分配到项目。',
  'sub.dashboard.instructions': '指示',
  'sub.dashboard.instructionsFromMgmt': '来自管理方',
  'sub.dashboard.noActiveInstructions': '没有待处理的指示——您已全部完成！',
  'sub.dashboard.actionRequired': '需要操作',
  'sub.dashboard.instructionsDueSoon': '{count} 个指示即将到期——点击查看',
  'sub.dashboard.subChecksPending': '{count} 个分包商检查待处理',
  'sub.dashboard.tapToOpenChecklist': '点击打开检查清单',
  'sub.dashboard.failedToLoad': '加载项目失败',
  'sub.dashboard.due': '到期',
  'sub.dashboard.stage': '阶段',
  'sub.dashboard.backToDashboard': '返回仪表板',
  'sub.dashboard.viewAll': '查看全部',

  // ── Sub Daily Log ──
  'sub.dailyLog.title': '每日日志',
  'sub.dailyLog.project': '项目',
  'sub.dailyLog.allProjects': '所有项目',
  'sub.dailyLog.photos': '照片',
  'sub.dailyLog.today': '今天',
  'sub.dailyLog.nonWorkingDay': '非工作日',
  'sub.dailyLog.noAssignedProjects': '未分配项目',
  'sub.dailyLog.noAssignedProjectsDesc': '您没有任何活跃的项目分配。',

  // ── Sub Instructions ──
  'sub.instructions.title': '指示',
  'sub.instructions.management': '管理',
  'sub.instructions.subcontractor': '分包商',
  'sub.instructions.allProjects': '所有项目',
  'sub.instructions.allStatus': '所有状态',
  'sub.instructions.open': '未处理',
  'sub.instructions.inReview': '审核中',
  'sub.instructions.resolved': '已解决',
  'sub.instructions.instructions': '指示',
  'sub.instructions.responseRequired': '需要回复',
  'sub.instructions.highPriority': '高优先级',
  'sub.instructions.due': '到期',
  'sub.instructions.overdue': '逾期',
  'sub.instructions.reply': '回复',
  'sub.instructions.sendReply': '发送回复',
  'sub.instructions.sending': '发送中...',
  'sub.instructions.progressUpdate': '进度更新',
  'sub.instructions.question': '问题',
  'sub.instructions.issueReport': '问题报告',
  'sub.instructions.completed': '已完成',
  'sub.instructions.acknowledge': '确认',
  'sub.instructions.markCompleted': '标记完成',
  'sub.instructions.cancel': '取消',
  'sub.instructions.attach': '附加',
  'sub.instructions.replySent': '回复发送成功',
  'sub.instructions.readMore': '查看更多',
  'sub.instructions.showLess': '收起',
  'sub.instructions.noInstructions': '暂无指示',
  'sub.instructions.noInstructionsProject': '{project} 暂无指示。',
  'sub.instructions.allCaughtUp': '已全部完成',
  'sub.instructions.noInstructionsFilter': '暂无{status}指示',
  'sub.instructions.unknownProject': '未知项目',
  'sub.instructions.linkedItem': '关联项目',

  // ── Sub Instructions NEW keys ──
  'sub.instructions.project': '项目',
  'sub.instructions.statusOpen': '未处理',
  'sub.instructions.statusInReview': '审核中',
  'sub.instructions.statusResolved': '已解决',
  'sub.instructions.statusSent': '已发送',
  'sub.instructions.statusCompleted': '已完成',
  'sub.instructions.statusClosed': '已关闭',
  'sub.instructions.priorityHigh': '高优先级',
  'sub.instructions.priorityMedium': '中优先级',
  'sub.instructions.priorityLow': '低优先级',
  'sub.instructions.acknowledged': '已确认',
  'sub.instructions.replyCount': '{count} 条回复',
  'sub.instructions.attachCount': '{count} 个附件',
  'sub.instructions.instructionCount': '{count} 个指示',
  'sub.instructions.selectProjectFirst': '请在上方选择一个项目。',
  'sub.instructions.noStatusInstructionsMsg': '暂无{status}指示',
  'sub.instructions.replySentSuccess': '回复发送成功',
  'sub.instructions.sendError': '发送回复失败',
  'sub.instructions.authError': '请先登录后再回复。',
  'sub.instructions.subcontractorRole': '分包商',
  'sub.instructions.justNow': '刚刚',
  'sub.instructions.minAgo': '{n} 分钟前',
  'sub.instructions.hrAgo': '{n} 小时前',
  'sub.instructions.hrsAgo': '{n} 小时前',
  'sub.instructions.dayAgo': '{n} 天前',
  'sub.instructions.daysAgo': '{n} 天前',
  'sub.instructions.dueDateLabel': '截止日期',
  'sub.instructions.today': '今天',
  'sub.instructions.yesterday': '昨天',

  // ── Sub Notifications ──
  'sub.notifications.title': '通知',
  'sub.notifications.all': '全部',
  'sub.notifications.unread': '未读',
  'sub.notifications.markAllRead': '全部标为已读',
  'sub.notifications.noNotifications': '暂无通知',
  'sub.notifications.noNotificationsDesc': '通知将显示在此处',
  'sub.notifications.allCaughtUp': '全部已读！',
  'sub.notifications.noUnread': '没有未读通知',

  // ── Sub Project Detail ──
  'sub.project.overview': '概览',
  'sub.project.schedule': '进度表',
  'sub.project.checklist': '检查清单',
  'sub.project.files': '文件',
  'sub.project.constructionJourney': '建造旅程',
  'sub.project.noStages': '阶段尚未设置。',
  'sub.project.projectInfo': '项目信息',
  'sub.project.site': '现场',
  'sub.project.startDate': '开始日期',
  'sub.project.estCompletion': '预计完工',
  'sub.project.recentUpdates': '最近更新',
  'sub.project.activeInstructions': '活跃指示',
  'sub.project.viewAll': '查看全部',
  'sub.project.dailyLog': '每日日志',
  'sub.project.dailyLogDesc': '按日期上传现场照片',
  'sub.project.instructions': '指示',
  'sub.project.instructionsDesc': '查看管理方请求',
  'sub.project.backToDashboard': '返回仪表板',
  'sub.project.backToProject': '返回 {project}',
  'sub.project.myChecklist': '我的检查清单',
  'sub.project.pending': '待处理',
  'sub.project.awaitingYourCheck': '等待您的确认',
  'sub.project.finalApproval': '最终审批',
  'sub.project.goToChecklist': '前往检查清单',
  'sub.project.pendingChecks': '{count} 个分包商检查待处理',
  'sub.project.pendingChecksDesc': '这些检查清单项目需要您的确认。管理方已经检查过。点击下方检查清单标签完成您的检查。',
  'sub.project.projectNotFound': '未找到项目',

  // ── Sub Stage Detail ──
  'sub.stage.stagePhotos': '阶段照片',
  'sub.stage.uploadPhoto': '上传照片',
  'sub.stage.noPhotos': '暂无照片——点击上传',
  'sub.stage.stageUpdates': '阶段更新',
  'sub.stage.postUpdate': '发布更新',
  'sub.stage.postUpdateTitle': '发布更新',
  'sub.stage.describeUpdate': '描述现场发生的情况...',
  'sub.stage.myChecklistItems': '我的检查清单项目',
  'sub.stage.pending': '待处理',
  'sub.stage.check': '确认',
  'sub.stage.completed': '已完成',
  'sub.stage.subcontractorCheckProgress': '分包商检查进度',
  'sub.stage.backToProject': '返回 {project}',
  'sub.stage.noScheduledStage': '无计划阶段',
  'sub.stage.noScheduledStageNonWork': '这是非工作日。',
  'sub.stage.noScheduledStageFound': '未找到此日期的计划阶段。',
  'sub.stage.inProgress': '进行中',
  'sub.stage.stageProgress': '阶段进度',
  'sub.stage.noPhotosYet': '暂无照片',
  'sub.stage.uploadPhotosForDay': '在上方上传此日期的照片',
  'sub.stage.savePhotos': '保存照片',
  'sub.stage.saving': '保存中...',
  'sub.stage.photoUploaded': '照片上传成功',
  'sub.stage.project': '项目',
  'sub.stage.scheduledStage': '计划阶段',
  'sub.stage.uploadPhotos': '上传照片',
  'sub.stage.dragDrop': '拖拽照片到此处',
  'sub.stage.orTapBelow': '或点击下方按钮',
  'sub.stage.gallery': '相册',
  'sub.stage.camera': '相机',
  'sub.stage.pendingUploads': '待上传',
  'sub.stage.clearAll': '全部清除',
  'sub.stage.photosForThisDay': '此日期的照片',
  'sub.stage.noPhotosYetUpload': '暂无照片',
  'sub.stage.readyToUpload': '{count} 个准备上传',
  'sub.stage.noPendingUploads': '没有待上传',
  'sub.stage.selectProjectFirst': '上传前请在上方选择特定项目。',
  'sub.stage.uploadDisabled': '上传已禁用',
  'sub.stage.uploadDisabledNonWork': '非工作日不可用照片上传。',
  'sub.stage.nonWorkingDay': '非工作日',
  'sub.stage.uploadNotAvailable': '照片上传不可用。',
  'sub.stage.updatesWillAppear': '发布更新后将显示在此处',
  'sub.stage.addPhoto': '添加照片',

  // ── Common Sub Labels ──
  'sub.common.progress': '进度',
  'sub.common.noDatesSet': '未设置日期',
  'sub.common.itemsCompleted': '{done}/{total} 项已完成',

  // ── Calendar month/weekday labels ──
  'sub.calendar.january': '一月',
  'sub.calendar.february': '二月',
  'sub.calendar.march': '三月',
  'sub.calendar.april': '四月',
  'sub.calendar.may': '五月',
  'sub.calendar.june': '六月',
  'sub.calendar.july': '七月',
  'sub.calendar.august': '八月',
  'sub.calendar.september': '九月',
  'sub.calendar.october': '十月',
  'sub.calendar.november': '十一月',
  'sub.calendar.december': '十二月',
  'sub.calendar.sun': '日',
  'sub.calendar.mon': '一',
  'sub.calendar.tue': '二',
  'sub.calendar.wed': '三',
  'sub.calendar.thu': '四',
  'sub.calendar.fri': '五',
  'sub.calendar.sat': '六',

  // ── Daily Log UI strings ──
  'sub.dailyLog.project': '项目',
  'sub.dailyLog.selectProject': '请在上方选择一个项目以查看或提交每日日志。',
  'sub.dailyLog.loadingStatus': '正在加载项目状态…',
  'sub.dailyLog.projectProgress': '项目进度',
  'sub.dailyLog.scheduleFinal': '进度最终',
  'sub.dailyLog.checklistFinal': '清单最终',
  'sub.dailyLog.complete': '% 完成',
  'sub.dailyLog.todayBtn': '今天',
  'sub.dailyLog.completedBadge': '已完成',
  'sub.dailyLog.pendingReview': '待审核',
  'sub.dailyLog.approved': '已批准',
  'sub.dailyLog.rejected': '已拒绝',
  'sub.dailyLog.internalOnly': '仅内部',
  'sub.dailyLog.mixed': '混合',
  'sub.dailyLog.submittedBadge': '已提交',
  'sub.dailyLog.logCountBadge': '{count} 条日志',
  'sub.dailyLog.photoCountBadge': '{count} 张照片',
  'sub.dailyLog.onePhotoBadge': '1 张照片',
  'sub.dailyLog.loadErrorTitle': '无法加载日报',
  'sub.dailyLog.retryLoad': '重试',
  'sub.dailyLog.noAssignedProjectsLong': '未分配项目',
  'sub.dailyLog.noAssignedProjectsLongDesc': '您没有任何活跃的项目分配。',
  'sub.dailyLog.selectProjectTitle': '选择项目',
  'sub.dailyLog.selectProjectDesc': '请在上方选择一个项目以查看或提交每日日志。',
  'sub.dailyLog.noPhotos': '照片',

  // ── Dashboard status labels ──
  'sub.dashboard.statusOpen': '未处理',
  'sub.dashboard.statusInReview': '审核中',
  'sub.dashboard.statusResolved': '已解决',
  'sub.dashboard.statusCompleted': '已完成',
  'sub.dashboard.overdue': '已逾期',
  'sub.dashboard.dueToday': '今天到期',
  'sub.dashboard.dueTomorrow': '明天到期',
  'sub.dashboard.dueSoon': '截止日期: {date}',
  'sub.dashboard.instructionsTitle': '指示',
  'sub.dashboard.unknownProject': '未知项目',
  'sub.dashboard.failedToLoadProjects': '加载项目失败',

  // ── Project page strings ──
  'sub.project.backToDashboard2': '返回仪表板',
  'sub.project.datesTBC': '日期待定',
  'sub.project.tbc': '待定',
  'sub.project.datesRange': '{start} — {end}',
  'sub.project.completedLabel': '已完成',
  'sub.project.inProgressLabel': '进行中',
  'sub.project.upcomingLabel': '即将开始',
  'sub.project.delayedLabel': '延迟',
  'sub.project.onHoldLabel': '暂停',
  'sub.project.generalUpdate': '一般',
  'sub.project.pendingChecksDesc': '这些检查清单项目需要您的确认。管理方已经检查过。点击下方检查清单标签完成您的检查。',
  'sub.project.dailyLogDesc2': '按日期上传现场照片',
  'sub.project.instructionsDesc2': '查看管理方请求',

  // ── Stage page strings ──
  'sub.stage.mgmtDone': '管理: 完成',
  'sub.stage.mgmtPending': '管理: 待处理',
  'sub.stage.subPending': '分包: 待处理',
  'sub.stage.subDone': '分包: 完成',
  'sub.stage.finalComplete': '最终: 完成',
  'sub.stage.waitingForSubcontractor': '等待分包商',
  'sub.stage.checkLabel': '确认',
  'sub.stage.progressTag': '进度',
  'sub.stage.issueTag': '问题',
  'sub.stage.completeTag': '完成',
  'sub.stage.backToProjectShort': '返回 {project}',
  'sub.stage.stageNotFound': '未找到阶段',
  'sub.stage.photoUploadedSuccess': '照片上传成功',
  'sub.stage.doneCount': '{completed}/{total} 完成',
};

export default translations;